export default __webpack_public_path__ + "static/media/stepsHeaderIcon.58705a53.svg";